// import { useLocalObservable } from 'mobx-react'
import { toQueryString } from "../utils/url";
import { getCurrentPage } from "./helper";
export const Page = (props)=>({
        _total: props.total,
        _limit: props.limit,
        _offset: props.offset,
        _pageSize: props.pageSize,
        get total () {
            return this._total || 0;
        },
        get limit () {
            return this._limit || 10;
        },
        get offset () {
            return this._offset || 0;
        },
        get pageSize () {
            return this._pageSize || this._limit || 10;
        },
        setCurrent (offset, limit, total) {
            this._offset = offset;
            this._limit = limit;
            if (total) {
                this._total = total;
            }
        },
        get current () {
            const page = getCurrentPage(this.offset, this.limit);
            return {
                offset: this.offset,
                limit: this.limit,
                total: this.total,
                page,
                current: page,
                pageSize: this.pageSize
            };
        },
        next (page) {
            const newOffset = this.limit * (page - 1);
            const newPage = getCurrentPage(newOffset, this.limit);
            return {
                offset: newOffset,
                limit: this.limit,
                total: this.total,
                page: newPage,
                current: newPage,
                pageSize: this.pageSize
            };
        }
    });
export const updatePageChangedWithRouterEvent = function(params, router) {
    let isReplace = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const urlParams = new URLSearchParams(params);
    let newQuery = {};
    const urlEntries = Object.fromEntries(urlParams.entries());
    if (Object.keys(urlEntries).length > 0) {
        newQuery = {
            ...newQuery,
            ...urlEntries
        };
    } else {
        const defaultParams = Object.keys(router.query).filter((key)=>key !== "offset" && key !== "limit" && key !== "slug");
        newQuery = {
            ...defaultParams
        };
    }
    if (isReplace) {
        return router.replace({
            pathname: router.pathname,
            query: {
                ...router.query,
                ...newQuery
            }
        }, undefined, {
            shallow: true,
            scroll: true
        });
    }
    router.push({
        // pathname: `${router.pathname}?${urlParams}`,
        // pathname: `/category/[slug]?${urlParams}`,
        pathname: router.pathname,
        query: {
            ...router.query,
            ...newQuery
        }
    }, undefined, // {
    // 	pathname: `/category/[slug]?${urlParams}`,
    // 	query: {
    // 		...router.query,
    // 	},
    {
        shallow: true,
        scroll: true
    });
// router.push(`${router.pathname}?${urlParams}`, { query: router.query }, { shallow: true })
// router.push(`${router.pathname}?${urlParams}`, undefined, { shallow: true })
// return
// window.history.replaceState(
// 	window.history.state,
// 	'',
// 	window.location.pathname + '?' + urlParams.toString(),
// )
};
export const deleteParamWithRouterEvent = function(key, router) {
    const newQuery = router.query;
    delete newQuery[key];
    router.push("".concat(router.pathname, "?").concat(toQueryString(newQuery)), undefined, {
        shallow: true
    });
};
